import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _defineProperty from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/defineProperty";

var ManagementCompanyStatusHelper =
/*#__PURE__*/
function () {
  function ManagementCompanyStatusHelper() {
    _classCallCheck(this, ManagementCompanyStatusHelper);

    _defineProperty(this, "STATUSES", {
      ACTIVE: {
        label: "Inactive",
        value: 0
      },
      INACTIVE: {
        label: "Active",
        value: 1
      },
      UNDER_CONSIDERATION: {
        label: "Under Consideration",
        value: 2
      }
    });
  }

  _createClass(ManagementCompanyStatusHelper, [{
    key: "GetStatusArray",
    value: function GetStatusArray() {
      return [this.STATUSES.ACTIVE, this.STATUSES.INACTIVE, this.STATUSES.UNDER_CONSIDERATION];
    }
  }, {
    key: "GetStatusLabel",
    value: function GetStatusLabel(id) {
      return this.GetStatusArray()[id];
    }
  }]);

  return ManagementCompanyStatusHelper;
}();

export default new ManagementCompanyStatusHelper();